import { useNavigate, useLocation } from 'react-router-dom';

export const usePayslipNavigateWithQuery = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  return (path) => {
    navigate(`${path}${search}`);
  };
};

export default usePayslipNavigateWithQuery;